import betconstructService from '../services/betconstruct.service';

const handlers = {
  betconstruct: {
    session: {
      set: 'betconstruct_session_set'
    }
  }
}

const initVuexState = function(state) {
  state.betconstruct = {
    session: null
  };
}

const initGetters = function(getters) {
  getters.betconstruct = (state => state.betconstruct);
}

const initActions = function(actions) {
  actions[handlers.betconstruct.session.set] = ({ commit }, session) => commit(handlers.betconstruct.session.set, session);
}

const initMutations = function(mutations) {
  mutations[handlers.betconstruct.session.set] = (state, session) => state.betconstruct.session = session;
}

const initAppState = function(appState, store) {
  appState.betconstruct = {
    session: {
      get: () => store.getters.betconstruct.session,
      open: async (gameId) => {
        let session = await betconstructService.openSession(gameId);
        store.dispatch(handlers.betconstruct.session.set, session);
      },
      openDemo: async (gameId) => {
        let session = await betconstructService.openDemoSession(gameId);
        store.dispatch(handlers.betconstruct.session.set, session);
      },
      close: async () => {
        if (store.getters.betconstruct.session) {
          await betconstructService.closeSession();
        }
        store.dispatch(handlers.betconstruct.session.set, null);
      }
    }
  }
}

export default {
  initVuex(vuexState, getters, actions, mutations) {
    initVuexState(vuexState);
    initGetters(getters);
    initActions(actions);
    initMutations(mutations);
  },
  initAppState(appState, store) {
    initAppState(appState, store);
  }
}



// WEBPACK FOOTER //
// ./_common/data/betconstruct.js